// Tracks products a shopper has peeked at (persisted in localStorage).
const KEY = 'nnl_recently_viewed';
const MAX = 8;

export const getRecentlyViewed = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};

export const addRecentlyViewed = (p) => {
  if (!p?.id) return;
  try {
    const item = {
      id: p.id,
      name: p.name,
      image: (p.gallery && p.gallery[0]) || p.image,
      price: p.price_by_length ? Math.min(...Object.values(p.price_by_length)) : p.price,
      fromPrice: !!p.price_by_length,
      category: p.category,
    };
    const list = getRecentlyViewed().filter((x) => x.id !== p.id);
    list.unshift(item);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('recentlyViewed persist failed', e);
  }
};
